import { Component, OnInit } from '@angular/core';
import { DropdownListOption } from "../../../../../shared/components/search-dropdown/search-dropdown.component";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TaxYearsService } from "../../../../../shared/util/tax-years.service";
import { TenantConfigService } from '../../../../../shared/services/tenant-config.service';
import { ConfigStateService } from '../../../../config/config-state.service';
import { Subscription } from 'rxjs';
import { TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-client-rules-builder-year-select',
    templateUrl: './client-rules-builder-year-select.component.html',
    styleUrls: ['./client-rules-builder-year-select.component.scss'],
    standalone: false
})
export class ClientRulesBuilderYearSelectComponent implements OnInit {
  taxYearOptions: DropdownListOption[];
  searchForm: UntypedFormGroup = new UntypedFormGroup({});
  taxYear: UntypedFormControl;
  yearLabel: string;
  uiConfig: TenantConfigService;
  subscriptions: Subscription[] = [];

  constructor(private taxYearsService: TaxYearsService, private config: ConfigStateService,private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    this.taxYearsService.getTaxYears().subscribe((years: any) => {
      this.taxYearOptions = years;
      const currYr = this.taxYearsService.getCurrentTaxYear();
      this.taxYear = new UntypedFormControl(currYr);
      this.searchForm.addControl("taxYear", this.taxYear);
    });
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.yearLabel = this.uiConfig.config.yearLabel;
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
      })
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
